module.exports = __webpack_public_path__ + "assets/58c35e5c73bbc1664bbd67c570342aa0.js";